import React, { useState, useEffect } from 'react';
import {NumericFormat} from 'react-number-format';
// import {useNumberFormat} from "@react-input/number-format";


function PercentageInput({ value, onChange, ...props }) {
  const [decimalScale, setDecimalScale] = useState(2);

  // Compute displayValue based on external value
  const displayValue = (typeof value === 'number' && !isNaN(value))
    ? (value * 100).toFixed(10).replace(/\.?0+$/, '')
    : '';

  return (
    <NumericFormat
      {...props}
      value={displayValue}
      decimalScale={10}
      fixedDecimalScale={false} // allow dynamic scale
      suffix="%"
      thousandSeparator={false}
      allowLeadingZeros={true}
      allowNegative={false}
      onValueChange={(values) => {
        const floatVal = values.floatValue;
        if (floatVal !== undefined && floatVal !== null) {
          onChange(floatVal / 100);
        } else {
          onChange(null);
        }
      }}
    />
  );
}

export default PercentageInput;

// function PercentageInput({ value, onChange, ...props }) {
//   // Default display value to "0.00" if value is null or undefined
//   const displayValue = (typeof value === 'number' && !isNaN(value))
//     ? (value * 100).toFixed(2)
//     : '0.00';
//
//   return (
//     <NumericFormat
//       {...props}
//       value={displayValue}
//       decimalScale={2}
//       fixedDecimalScale={true}
//       suffix="%"
//       thousandSeparator={false}
//       allowLeadingZeros={true}
//       allowNegative={false}
//       onValueChange={(values) => {
//         const floatVal = values.floatValue;
//         if (floatVal !== undefined && floatVal !== null) {
//           onChange(floatVal / 100);
//         } else {
//           onChange(null);
//         }
//       }}
//     />
//   );
// }


function DollarInput({ value, onChange, ...props }) {
  // Default display value to "0.00" if value is null or undefined
  const displayValue = (typeof value === 'number' && !isNaN(value))
    ? (value).toFixed(2)
    : '$';

  return (
    <NumericFormat
      {...props}
      value={displayValue}
      decimalScale={2}
      fixedDecimalScale={true}
      prefix="$"
      thousandSeparator={true}
      allowLeadingZeros={false}
      allowNegative={false}
      onValueChange={(values) => {
        const floatVal = values.floatValue;
        if (floatVal !== undefined && floatVal !== null) {
          onChange(floatVal);
        } else {
          onChange(null);
        }
      }}
    />
  );
}

export {DollarInput, PercentageInput};

// function PercentageInput({ value, onChange }) {
//   const [displayValue, setDisplayValue] = useState('');
//
//   // Sync external value to display
//   useEffect(() => {
//     if (value !== undefined && value !== null) {
//       // Convert decimal to percent string, e.g., 0.08 -> "8.00"
//       setDisplayValue((value * 100));
//     }
//   }, [value]);
//
//   const handleChange = (e) => {
//     let val = e.target.value;
//
//     // Remove '%' if user types it manually
//     val = val.replace(/\%/g, '');
//     // Remove whitespace
//     val = val.trim();
//
//     // Parse float
//     const num = parseFloat(val);
//     if (!isNaN(num)) {
//       // Call onChange with decimal
//       onChange(parseFloat((num / 100).toFixed(6))); // limit decimal precision
//     } else {
//       onChange(null);
//     }
//
//     // Set display to the number with '%' appended
//     setDisplayValue(val + '%');
//   };
//
//   // To prevent disappearing % when focus leaves, handle onBlur
//   const handleBlur = () => {
//     // Remove % symbol if present
//     let val = displayValue.replace(/\%/g, '').trim();
//     if (val === '' || isNaN(parseFloat(val))) {
//       setDisplayValue('');
//     } else {
//       // Reformat to fixed decimal + '%'
//       setDisplayValue(parseFloat(val) + '%');
//     }
//   };
//
//   return (
//     <input
//       type="text"
//       value={displayValue}
//       onChange={handleChange}
//       onBlur={handleBlur}
//       style={{ width: '100%' }}
//     />
//   );
// }
//
// export default PercentageInput;